import React, { createContext, useContext, useState, useCallback } from 'react'
import CopyToast from '../components/CopyToast'

interface CopyContextType {
  copyText: (text: string, message?: string) => void
}

const CopyContext = createContext<CopyContextType>({ copyText: () => {} })

export function CopyProvider({ children }: { children: React.ReactNode }) {
  const [visible, setVisible] = useState(false)
  const [message, setMessage] = useState('Copied to clipboard!')
  const [key, setKey] = useState(0)

  const copyText = useCallback(async (text: string, msg?: string) => {
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
    setMessage(msg || 'Copied to clipboard!')
    setVisible(false)
    setKey(prev => prev + 1)
    setTimeout(() => setVisible(true), 10)
    setTimeout(() => setVisible(false), 2100)
  }, [])

  return (
    <CopyContext.Provider value={{ copyText }}>
      {children}
      <CopyToast key={key} isVisible={visible} message={message} />
    </CopyContext.Provider>
  )
}

export function useCopyContext() {
  return useContext(CopyContext)
}
